export const information = {
  site: "f168",
  cskh_url: "https://f1681.bar/trangchu",
  cskh_home: "https://f1681.bar/trangchu",
  endpoint: "https://api-freecode-f168.freecodevip.org",
  follow_code: "https://t.me/f168freecode",
  follow_tele: "https://f1681.email/social/telegram",
  follow_fb: "https://f1681.email/social/facebook",
  follow_insta: "https://f1681.email/social/insta",

  follow_detail_code: "https://f1681.cc//home/event/item/1/42?current=1",
  key_free: "f168apt.code.free-code.f168@2030$F168ff",
};
